<template>
  <div class="loader" v-show="showLoadingAnimation">
    <div>
      <div class="point"></div>
      <div class="point"></div>
      <div class="point"></div>
      <div class="point"></div>
      <div class="point"></div>
    </div>
  </div>
</template>
;
<script>
  import { mapState } from 'vuex'
  export default {
    data () {
      return {
        test: 1
      }
    },
    computed: {
      ...mapState(['showLoadingAnimation'])
    }
  }
</script>  +

<style lang="scss" scoped>
  .loader {
    position: absolute;
    height: 100%;
    width: 100%;
    z-index: 900;
    display: flex;
    justify-content: center;
    align-items: center;
/*    background-color: #E6E6E6;*/
  }
  .point {
    width: 4rem;
    height: 4rem;
    border-radius: 100%;
    display: inline-block;
    background: #0875ba;
    animation: transform 2s infinite;
  }
  @for $i from 1 to 6 {
    .point:nth-child(#{$i}){
      animation-delay: .1s * $i;
      background: darken(#0875ba, 10%);
    }
  }
  @keyframes transform {
    0% {
      transform: scale(1);
    }
    50% {
      opacity: .3;
      transform: scale(1.5);
    }
    100% {
      transform: scale(1);
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/loading.vue